import React from 'react'
import { useUserAPI } from '@SonarCX/providers/UserAPIProvider'
import Card from '@SonarCX/components/atoms/MediaAvatar/Card'
import useStyles from './../../styles'

const HomeContacts = ({ latestContacts }) => {
  const { allUsers, loadUser, loaded: usersLoaded } = useUserAPI()
  const [fullContacts, setFullContacts] = React.useState([])

  const classes = useStyles()

  React.useEffect(() => {
    if (!usersLoaded) return
    for (const latestContact of latestContacts) {
      const foundUser = allUsers[latestContact]

      if (foundUser && foundUser.id) {
        if (fullContacts.find(contact => contact.id === foundUser.id)) continue
        setFullContacts(old => [...old, foundUser].filter(Boolean))
      } else {
        loadUser(latestContact)
      }
    }
  }, [usersLoaded, allUsers, loadUser, latestContacts, fullContacts])
  return (
    <>
      <h5 className={classes.sectionHeader}>Recent contacts</h5>

      <div className={classes.dataContainer}>
        {fullContacts.map((user: any) => (
          <Card
            key={user.id}
            // @ts-ignore
            hideHeader
            rootStyles={classes.contactBackground}
            user={user}
          />
        ))}
      </div>
    </>
  )
}
export default HomeContacts
